import { useEffect, useState } from 'react';

/**
 * Custom hook for watching and responding to a given media query
 * @param {string} query - media query to watch
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => {
      setMatches(media.matches);
    };
    try {
      media.addEventListener('change', listener);
    } catch {
      // Required for Safari < 14
      media.addListener(listener);
    }
    return () => {
      try {
        media.removeEventListener('change', listener);
      } catch {
        // Required for Safari < 14
        media.removeListener(listener);
      }
    };
  }, [matches, query]);

  return matches;
}
